import { cn } from '@/lib/utils';

export default function H6({ children, className }: { children: string; className?: string }) {
    return (
        <h6
            className={cn(
                'text-black max-lg:text-md lg:text-h6 font-bold uppercase leading-none',
                className,
            )}
        >
            {children}
        </h6>
    );
}
